<template>
  <component :is="tag" class="leaders-nav__item">
    <slot :booths="booths" />
  </component>
</template>
<script>
const { log } = console;

const query = ({ salesforceAccountId, boothShowId }) => `
  query {
    company: companyById(input: { id: "${salesforceAccountId}" }) {
      _id
      booths(input: { showId: "${boothShowId}" }) {
        id
        accountId
        boothNumber
      }
    }
  }
`;

export default {
  props: {
    tag: {
      type: String,
      default: 'li',
    },
    boothShowId: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    booths: [],
  }),

  async mounted() {
    if (this.item.salesforceAccountId && this.boothShowId) {
      const { item, boothShowId } = this;
      const { salesforceAccountId } = item;
      const response = await fetch('https://www.prosource.org/graphql', {
        body: JSON.stringify({ query: query({ salesforceAccountId, boothShowId }) }),
        headers: { 'content-type': 'application/json' },
        method: 'POST',
      });
      const jsonResponse = await response.json();
      if (!response.ok) {
        log('Unsuccessful external API response!', jsonResponse);
      }
      this.booths = jsonResponse.data.company.booths;
    }
  },
};
</script>
